import { Mui } from "@osu/react-ui";
import Fieldset from "../Fieldset";
import { Fragment } from "react/jsx-runtime";
import Switch from "../../Switch";
import { useReducer, useState } from "react";
import useStoredFormValue from "../../../../hooks/useStoredFormValue";

const { FormControlLabel, RadioGroup, Radio } = Mui;

const fieldSetStyles = (theme) => {
  const baseSpace = theme.spacing();
  return {
    [` & > *:not(:last-child), & > .${Mui.formControlClasses.root}:not(:last-child)`]:
      {
        marginBottom: theme.spacing(3),
      },
    " legend:first-child": {
      ...theme.typography.h6,
      marginBottom: theme.spacing(2),
    },
    paddingLeft: theme.spacing(3),
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: baseSpace,
      background: theme.palette.divider,
      borderRadius: baseSpace,
    },
  };
};

const reducer = (state, payload) => {
  let map = state || new Map()
  const field = payload?.name || payload?.id
  if(field) {
    map.set(field, payload?.value || "")
  }
  return map
};

const CustomSwitch = ({ id,cachedValue, setCache, ...props }) => {
  const { value: defaultValue } = useStoredFormValue({
    questionId: id,
    name: props?.name,
  });
  const [val, setVal] = useState(cachedValue || defaultValue);
  return (
    <Switch
      id={id}
      {...props}
      value={val}
      setValue={(newValue) => {
        setVal(newValue);
        setCache({
          name: props?.name,
          id,
          value: newValue
        });
      }}
    />
  );
};

const radioSx = {
  [`& .${Mui.formControlLabelClasses.asterisk}`]: {
    display: "none"
  }
}

function Choices({ choices = [], readOnly, value: parentValue, required, ...props }) {
  const [cache, setCache] = useReducer(
    reducer,
    new Map()
  );

  return (
    <RadioGroup value={parentValue} readOnly={readOnly} {...props}>
      {choices.map(
        (
          {
            label: choiceLabel,
            value: choiceValue,
            id,
            relatedQuestionsId: _relatedQuestionsId,
            relatedQuestions = [],
            relatedQuestionsLegend,
            ...rest
          },
          idx
        ) => {
          const isSelected = choiceValue === parentValue;
          const relatedQuestionsId =
            _relatedQuestionsId || id + "-related-qs-" + idx;
          const key = id + choiceValue + idx;
          const shouldShowQuestions = Boolean(
            isSelected && relatedQuestions?.length
          );

          return (
            <Fragment key={key}>
              <FormControlLabel
                label={choiceLabel}
                value={choiceValue}
                control={<Radio required={required} />}
                id={id}
                aria-controls={shouldShowQuestions && relatedQuestionsId}
                aria-expanded={shouldShowQuestions}
                disabled={readOnly}
                sx={radioSx} 
              />
              <Fieldset
                legend={shouldShowQuestions && relatedQuestionsLegend}
                id={relatedQuestionsId}
                sx={fieldSetStyles}
              >
                {shouldShowQuestions &&
                  relatedQuestions.map((rq, idx) => {
                    const switchProps = { ...rq, fullWidth: true };
                    return (
                      <CustomSwitch
                        {...switchProps}
                        readOnly={readOnly}
                        key={idx + rq.id}
                        setCache={setCache}
                        cachedValue={cache?.get(rq?.name) || cache?.get(rq?.id)}
                      />
                    );
                  })}
              </Fieldset>
            </Fragment>
          );
        }
      )}
    </RadioGroup>
  );
}

export default Choices;
